import controller from './radio-status.controller';

const template = require('./radio-status.html');

export default {
    bindings: {
        radio: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/common/radio-status/radio-status.component.js